import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import {Http, Credential, BASE_URL} from 'common'
import {AuthOptions} from '../../utils'

import {
    AuthPage, Window, TabBar, Form, Input,
    Checkbox, PhoneHint, PasswordHint,
    Parallax, License, Providers, ProviderItem,
    LinkButton
} from 'common/components'

import {Link} from 'react-router-dom'
import {Row, Col, Tooltip, Popover} from 'antd'

import SignInForm from './SignIn'
import SignUpForm from './SignUp'


export default class SessionCreate extends React.Component {
    state = {tab: 'login'}

    heading = ['Київ ID', 'Єдиний обліковий запис киянина']
    tabs = [['login', 'Увійти'], ['registration', 'Створити']]

    handleTabChange = (tab) =>
        this.setState({tab})

    handleSignUpComplete = () =>
        this.refs.tabbar.reset()


    render() {
        const {tab} = this.state
        const {location} = this.props
        const params = {
            ...qs.parse(location.search),
            ...qs.parse(window.location.search)
        }

        const options = new AuthOptions(params)
        const inputs = options.inputs()

        const picture = tab === 'login' ? 'laptop' : 'desktop'

        return (
            <Window heading={this.heading} picture={picture}>
                {!!inputs.length &&
                    <TabBar
                        ref='tabbar'
                        items={this.tabs}
                        onChange={this.handleTabChange}
                    />
                }

                {tab === 'login' && <SignInForm params={params} /> }
                {tab === 'registration' && <SignUpForm params={params} onComplete={this.handleSignUpComplete} /> }
            </Window>
        );
    }
}